// What a job or RFP save sends for the company's preferred network: a job's optional "Apply by"
// date, written the way an RFP's submission deadline is, its "alert people within" distance, and the "tell your preferred network"
// choices from the publish step, sent only when a box is ticked. The server decides whether the
// save is the one that makes the posting live, and acts only then. Who the posting is open to is sent
// when it was chosen; without it the server keeps the stored value, or uses the company's setting.

import { parseVisibility } from './postingVisibilityValues';

const isJob = payload =>
  !!(payload && (payload.updateJobListing || payload.createNewJobListing || payload.createNewJobDraftListing || payload.listingType === 'job_listing'));

// How far from an on-site or hybrid job its alerts reach, in whole kilometres; null leaves the
// server's default.
const alertRadiusOf = value => {
  const radius = typeof value === 'string' && value.trim() !== '' ? Number(value) : value;
  return Number.isInteger(radius) && radius > 0 ? radius : null;
};

export const postingNetworkFields = payload => {
  const fields = {};
  if (isJob(payload)) {
    fields.applyByJob = payload.applyByJob?.date?.toDateString() || '';
    fields.alertRadiusKmJob = alertRadiusOf(payload.alertRadiusKmJob);
  }
  const visibility = parseVisibility(payload?.visibility);
  if (visibility) fields.visibility = visibility;
  const tell = payload?.tellNetwork;
  if (tell && (tell.talent === true || tell.suppliers === true)) {
    fields.tellNetwork = {
      talent: tell.talent === true,
      suppliers: tell.suppliers === true,
      note: typeof tell.note === 'string' ? tell.note : '',
    };
  }
  return fields;
};
